import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_DEFINITION } from './actions';
import CalcType from 'state/Constants/CalcType';
import { selectDefinitions, selectFetchingData } from './selectors';
import SelectionState from 'state/selections/SelectionState';

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const { issueCountType, calcType, key } = definition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Issue Count ${issueCountType} - Acc`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Issue Count ${issueCountType} - Rel`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Issue Count ${issueCountType} - Bench`;
          columnDef.loading = fetchingAbsData && fetchingRelData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }
      columnDefs.push(columnDef);
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, fetchingRelData]);
};
